import api from './api';

export const createClass = async (classData) => {
  const response = await api.post('/classes/', classData);
  return response.data;
};

export const createRecurringClasses = async (recurringData) => {
  const response = await api.post('/classes/recurring', recurringData);
  return response.data;
};

export const getClassesByProject = async (projectId) => {
  const response = await api.get(`/classes/project/${projectId}`);
  return response.data;
};

export const getClassById = async (classId) => {
  const response = await api.get(`/classes/${classId}`);
  return response.data;
};

export const updateClass = async (classId, classData) => {
  const response = await api.put(`/classes/${classId}`, classData);
  return response.data;
};

export const rescheduleClass = async (classId, rescheduleData) => {
  // rescheduleData: { new_date, new_time, duration_minutes?, meet_link? }
  const response = await api.patch(`/classes/${classId}/reschedule`, rescheduleData);
  return response.data;
};

export const cancelClass = async (classId, cancelSeries = false) => {
  const response = await api.patch(`/classes/${classId}/cancel`, {
    cancel_series: cancelSeries,
  });
  return response.data;
};

export const logClassSummary = async (classId, logData) => {
  const response = await api.post(`/classes/${classId}/log`, logData);
  return response.data;
};

export const getUpcomingClasses = async () => {
  const response = await api.get('/classes/upcoming/mentor');
  return response.data;
};

export const requestDurationOverride = async (classId, { manual_duration_minutes, reason }) => {
  const response = await api.post(`/classes/${classId}/duration-override`, { manual_duration_minutes, reason });
  return response.data;
};

export const getDurationOverridesAwaitingApproval = async () => {
  const response = await api.get('/classes/duration-overrides/awaiting-approval');
  return response.data;
};

export const approveDurationOverride = async (classId, feedback = null) => {
  const response = await api.post(`/classes/${classId}/duration-override/approve`, null, {
    params: { feedback },
  });
  return response.data;
};

export const rejectDurationOverride = async (classId, feedback) => {
  const response = await api.post(`/classes/${classId}/duration-override/reject`, null, {
    params: { feedback },
  });
  return response.data;
};